var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrap"
  }, [_c('main-header'), _c('v-main', {
    staticClass: "main"
  }, [_vm._t("default")], 2), _c('user-qrcode'), _c('main-footer'), _c('ScrollTop')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }